<template>
  <div>
    <loading-indicator>
      <alerts-modal :alerts="modalAlerts" />
      <alerts-subscribe-modal :alerts="modalAlertsSubscribe" />
      <logbook-modal :data="modalLogbookData" />
      <orders-modal :orders="modalOrders" />
      <weather-modal :weather-data="modalWeatherData" />
      <folio-modal :folio="modalFolioData" />
      <agreement-modal :agreement="modalAgreementData" />
      <deliveries-modal :deliveries="modalDeliveries" />
      <add-ship-modal />
      <q-r-scanner-dialog />
      <home-ecdis :selected_row="selected_row" />
  
      <b-modal id="qr-code-modal" title="Telegram Bot Registration" hide-footer>
        <div v-if="qrCodeUrl" class="text-center">
          <p>Scan this QR code with your phone to get alerts in Telegram.</p>
          <img :src="qrCodeUrl" alt="QR Code" style="max-width: 100%; height: auto">
        </div>
        <div v-else class="text-center">
          <b-spinner :label="$t('general.loading', 'Loading...')" />
          <p>Loading QR code...</p>
        </div>
      </b-modal>
  
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col order="4" order-lg="1" lg="4">
                <div class="d-flex align-items-center mt-2 mb-2">
                  <b-link v-if="isMobile" class="mr-2 mobile-nav-icon"
                    @click="activeMobileView = activeMobileView === 'table' ? 'map' : 'table'" v-b-tooltip
                    :title="activeMobileView === 'table' ? 'Show map' : 'Show table'">
                    <i :class="activeMobileView === 'table' ? 'fas fa-map-marker-alt' : 'fas fa-table'" />
                  </b-link>
  
                  <b-link v-if="isMobile && activeMobileView === 'map'" class="mr-2 mobile-nav-icon"
                    @click="$router.push('routes')" v-b-tooltip title="Routes">
                    <i class="fas fa-route" />
                  </b-link>
  
                  <b-link v-if="!isMobile || activeMobileView === 'table'" class="collapse-icon"
                    @click="collapseAllDetails()" v-b-tooltip title="Collapse all">
                    <i class="fas fa-angle-double-up" />
                  </b-link>
  
                  <b-link v-if="!isMobile || activeMobileView === 'table'" class="ml-2 refresh-icon"
                    @click="refreshData()" v-b-tooltip title="Refresh data">
                    <i class="fas fa-sync-alt" />
                  </b-link>
  
                  <b-link v-if="!isMobile || activeMobileView === 'table'" class="ml-2 add-ship-icon" @click="addShip()"
                    v-b-tooltip :title="$t('fleet.noShipsFound')">
                    <i class="fas fa-plus-circle" />
                  </b-link>
  
                  <b-link v-if="!isMobile || activeMobileView === 'table'" class="ml-2 search-icon"
                    @click="toggleSearchBar" v-b-tooltip title="Search ships">
                    <i class="fas fa-search" />
                  </b-link>
  
                  <b-link v-if="!isMobile || activeMobileView === 'table'" class="ml-2 qr-icon" @click="showQRServiceCode"
                    v-b-tooltip title="QR alert service code">
                    <i class="fas fa-qrcode" />
                  </b-link>
  
                  <b-form-input v-if="showSearchBar" v-model="searchQuery" size="sm" class="ml-2 search-input"
                    placeholder="Search ships..." @input="filterTable" />
                </div>
  
                <div v-if="!isMobile || activeMobileView === 'table'" class="ships-container">
                  <div v-if="tableItems && tableItems.length > 0">
                    <b-table ref="fleetTable" :items="tableItems" :fields="shipTableFields" hover responsive
                      class="ship-table" tbody-tr-class="ship-row" @row-clicked="handleRowClick"
                      :tbody-tr-attr="rowAttributes" no-border-collapse>
                      <template #cell(summary)="row">
                        <div class="summary-header">
                          <div class="summary-top-row">
                            <div class="summary-left ship-name">
                              {{ row.item.ship.name }}
                            </div>
                            <div class="summary-right">
                              <i class="fas fa-cloud-sun action-icon mr-2 light-icon" v-b-tooltip title="Weather"
                                :class="getWeatherIconClass(row.item.ship.deviceId)"
                                @click.stop="showWeatherData(row.item.ship.deviceId)" />
  
                              <!--                            {{fleetStore.alerts?.folio?.[row.item.ship.deviceId]?.charts?.length}}-->
  
                              <i class="fas fa-map action-icon mr-2 light-icon" v-b-tooltip
                                :title="$t('menu.folio', 'Folio')" :class="{
                                                              'text-success': !fleetStore.hasFolioAlert(row.item.ship.deviceId) && fleetStore.alerts?.folio?.[row.item.ship.deviceId]?.charts?.length > 0,
                                                              'text-danger': fleetStore.hasFolioAlert(row.item.ship.deviceId),
                                                              '': !fleetStore.alerts?.folio?.[row.item.ship.deviceId] || fleetStore.alerts?.folio?.[row.item.ship.deviceId]?.charts?.length === 0
                                                            }"
                                @click.stop="showFolioAlertDetails(row.item.ship.deviceId)" />
                              <i class="fas fa-map-marker-alt action-icon mr-2 light-icon" v-b-tooltip
                                title="Navarea Warnings" :class="getNavareaIconClass(row.item.ship.deviceId)"
                                @click.stop="showNavareaWarnings(row.item.ship.deviceId)" />
  
                              <i class="fas fa-exclamation-triangle action-icon mr-2 light-icon" v-b-tooltip
                                title="Alerts" :class="{ 'text-danger': row.item.alerts && row.item.alerts.length > 0 }"
                                @click.stop="showLogbookDetails(row.item.logbook)" />
  
                              <i class="fas fa-file-alt action-icon light-icon" v-b-tooltip title="Logbook"
                                :class="{ 'text-danger': row.item.alerts && row.item.alerts.length > 0 }"
                                @click.stop="showLogbookDetails(row.item.logbook)" />
                            </div>
                          </div>
  
                          <div class="summary-bottom-row"
                            v-if="fleetStore.AISData && fleetStore.AISData[row.item.ship.deviceId]">
                            <div class="summary-left destination-eta">
                              DST: {{ fleetStore.AISData[row.item.ship.deviceId].destination || 'N/A' }}, ETA: {{
                              formatETA(fleetStore.AISData[row.item.ship.deviceId].eta) }} GMT
                            </div>
                          </div>
  
                          <div class="summary-bottom-row mt-2">
                            <div class="summary-left">
                              <b-badge :variant="getAISTimeBasedVariant(row.item.ship.deviceId)" pill
                                class="normal-weight-badge custom-ship-badge">
                                <strong>{{ getAISStatus(row.item.ship.deviceId) }}</strong>
                                <template
                                  v-if="getAISStatus(row.item.ship.deviceId) !== $t('general.noPosition', 'no position')">
                                  <br>
                                  {{ formatAISTime(row.item.ship.deviceId) }}
                                </template>
                              </b-badge>
                            </div>
                            <div class="summary-right">
                              <a class="smt17" href="#"
                                @click.stop="showAgreementDetails(row.item.ship.deviceId, row.item.ship.agreement)">
                                {{ row.item.ship.agreement ? 'Agr: ' + row.item.ship.agreement : 'Stripe'
                                }}
                              </a>
                            </div>
                          </div>
                        </div>
                      </template>
  
                      <!-- Отображаем детали при клике по ячейке -->
                      <template #row-details="row">
                        <div class="ship-details-content">
                          <!--
                                <div v-if="row.item.ship.agreement === ''">
                                  <dt />
                                  <dd class="width: 100%">
                                    <b-button @click="$router.push('distributors')" size="sm" variant="info" block
                                      class="w-100">
                                      Choose a distributor
                                    </b-button>
                                  </dd>
                                </div>
                                -->
  
                          <div v-if="formatAISTime(row.item.ship.deviceId)">
                            <dt>AIS updated</dt>
                            <dd>
                              {{ formatAISTime(row.item.ship.deviceId) }}
                              <template v-if="fleetStore.AISData && fleetStore.AISData[row.item.ship.deviceId]">
                                <br>
                                Position: {{ formatPosition(fleetStore.AISData[row.item.ship.deviceId].payload.Position)
                                }}
                                <span v-if="isMobile">
                                  (
                                  <b-link @click.prevent="activeMobileView = 'map'" class="on-map-link">on map</b-link>
                                  )
                                </span>
                                <template v-if="fleetStore.AISData[row.item.ship.deviceId].payload.CourseOverGround">
                                  <br>
                                  COG: {{ fleetStore.AISData[row.item.ship.deviceId].payload.CourseOverGround }}°
                                </template>
                                <template v-if="fleetStore.AISData[row.item.ship.deviceId].destination">
                                  <br>
                                  DST: {{ fleetStore.AISData[row.item.ship.deviceId].destination }}
                                </template>
                                <template v-if="fleetStore.AISData[row.item.ship.deviceId].eta">
                                  <br>
                                  ETA: {{ formatETA(fleetStore.AISData[row.item.ship.deviceId].eta) }}
                                </template>
                              </template>
                            </dd>
                          </div>
  
                          <div v-if="fleetStore.hasAnyAlerts(row.item.ship.deviceId)" class="alert-container">
                            <dt />
                            <dd>
                              <dl>
                                <!-- Weather alert -->
                                <div v-if="hasAlert(row.item.ship.deviceId, 'Wind')"
                                  class="custom-alert alert-danger mb-2">
                                  <dt>Weather Alert</dt>
                                  <dd>
                                    {{ getAlertText(row.item.ship.deviceId, 'Wind') }}
                                  </dd>
                                </div>
  
                                <!-- Folio alert -->
                                <div v-if="fleetStore.hasFolioAlert(row.item.ship.deviceId)" class="mb-2">
                                  <dt>Charts missing</dt>
                                  <dd>
                                    The ship is missing the most detailed chart ({{
                                    fleetStore.alerts?.folio?.[row.item.ship.deviceId]?.mostDetailed }}) for its current
                                    position. Available charts:
                                    {{ fleetStore.getFolioCharts(row.item.ship.deviceId).join(', ') }}.
                                    <br>
                                    <b-link href="#"
                                      @click.prevent="$router.push({ name: 'routes', params: { openTab: 'orders' } })">
                                      purchase...
                                    </b-link>
                                  </dd>
                                </div>
  
                                <!-- Navarea alert -->
                                <div v-if="hasAlert(row.item.ship.deviceId, 'NavArea')"
                                  class="custom-alert alert-danger mb-2">
                                  <dt>Navarea Alert</dt>
                                  <dd>
                                    {{ getAlertText(row.item.ship.deviceId, 'NavArea') }}
                                  </dd>
                                </div>
  
                                <!-- Logbook alert -->
                                <div
                                  v-if="getLatestLogbookEntry(row.item.ship.deviceId) && getLatestLogbookEntry(row.item.ship.deviceId).type === 'error'"
                                  class="custom-alert alert-danger mb-2">
                                  <dt>Logbook Issue</dt>
                                  <dd>
                                    {{ getLatestLogbookEntry(row.item.ship.deviceId).message || 'Error reported in ship
                                    logbook' }}
                                    <div class="mt-1">
                                      <b-button size="sm" variant="outline-danger"
                                        @click="showLatestLogbookDetails(row.item.ship.deviceId)">
                                        View Details
                                      </b-button>
                                    </div>
                                  </dd>
                                </div>
                              </dl>
                            </dd>
                          </div>
  
                          <hr>
  
                          <div>
                            <dt>{{ $t('fleet.account') }}</dt>
                            <dd>{{ row.item.ship.email }}</dd>
                          </div>
  
                          <div>
                            <dt>Payment method</dt>
                            <dd>{{ row.item.ship.agreement ? 'Agreement: ' + row.item.ship.agreement : 'Stripe' }}</dd>
                          </div>
  
                          <div>
                            <dt>{{ $t('general.dataProvider', 'Data provider') }}</dt>
                            <dd>{{ row.item.ship.provider ? row.item.ship.provider : 'Primar' }}</dd>
                          </div>
  
                          <hr>
  
                          <div>
                            <dt>Transactions</dt>
                            <dd>
                              <template v-if="getShipOrders(row.item.ship.deviceId).length > 0">
                                {{ getShipOrders(row.item.ship.deviceId).length }} {{ $t('fleet.orders') }}
                                <template v-if="getShipOrders(row.item.ship.deviceId).length > 0">
                                  ({{ $t('fleet.latest') }}: #{{ getLatestOrder(row.item.ship.deviceId).displayId }}, {{
                                  formatOrderDate(getLatestOrder(row.item.ship.deviceId).updatedAt) }},
                                  {{ getOrderPrice(getLatestOrder(row.item.ship.deviceId)) }})
                                  <b-link href="#"
                                    @click.prevent="showOrderDetails(getShipOrders(row.item.ship.deviceId))">
                                    {{ $t('fleet.more') }}...
                                  </b-link>
                                </template>
                              </template>
                              <template v-else>
                                {{ $t('fleet.noOrders') }}
                              </template>
                            </dd>
                          </div>
  
                          <div>
                            <dt>Folio</dt>
                            <dd>
                              <template v-if="fleetStore.folio && fleetStore.folio.length">
                                <template v-if="hasDeviceFolioData(row.item.ship.deviceId)">
                                  <b-button size="sm" :variant="getFolioIconVariant(row.item.ship.deviceId)"
                                    @click="showFolioAlertDetails(row.item.ship.deviceId)" class="mr-2">
                                    <i class="fas fa-map" />
                                  </b-button>
  
                                  <template v-if="countItemsByType(row.item.ship.deviceId, 's63 maps') > 0">
                                    ENC: {{ countItemsByType(row.item.ship.deviceId, 's63 maps') }}
</template>
                                  <template v-if="countItemsByType(row.item.ship.deviceId, 'AVCS maps') > 0">
  <template v-if="countItemsByType(row.item.ship.deviceId, 's63 maps') > 0">
                                      ,
</template>
                                    AVCS: {{ countItemsByType(row.item.ship.deviceId, 'AVCS maps') }}
                                  </template>
                                  <template v-if="countItemsByType(row.item.ship.deviceId, 'ADP') > 0">
                                    <template v-if="countItemsByType(row.item.ship.deviceId, 's63 maps') > 0 || countItemsByType(row.item.ship.deviceId, 'AVCS maps') > 0">
  ,
</template>
                                    ADP: {{ countItemsByType(row.item.ship.deviceId, 'ADP') }}
                                  </template>
                                  <template v-if="countItemsByType(row.item.ship.deviceId, 'ENP') > 0">
                                    <template
                                      v-if="
                                        countItemsByType(row.item.ship.deviceId, 's63 maps') > 0 ||
                                        countItemsByType(row.item.ship.deviceId, 'AVCS maps') > 0 ||
                                        countItemsByType(row.item.ship.deviceId, 'ADP') > 0
                                      "
                                    >
  ,
</template>
                                    eNP: {{ countItemsByType(row.item.ship.deviceId, 'ENP') }}
                                  </template>
                                  <b-link href="#" @click.prevent="showFolioDetails(getPaidFolioItems(row.item.ship.deviceId))">
more...
</b-link>
                                </template>
                                <template v-else>
No folio data
</template>
                              </template>
                              <template v-else>
No folio data
</template>
                            </dd>
                          </div>

                          <div>
                            <dt>Deliveries</dt>
                            <dd>
                              <template v-if="getShipDeliveries().length > 0">
                                {{ getShipDeliveries().length }} updates
                                <template v-if="getShipDeliveries().length > 0">
                                  ({{ $t('fleet.latest') }}: {{ formatDeliveryDate(getLatestDelivery()) }})
                                  <b-link href="#" @click.prevent="showShipDeliveries">
{{ $t('fleet.more') }}...
</b-link>
                                </template>
                              </template>
                              <template v-else>
                                {{ $t('fleet.deliveries') }}
                              </template>
                            </dd>
                          </div>

                          <div>
                            <dt>Logbook</dt>
                            <dd>
                              <template v-if="getLatestLogbookEntry(row.item.ship.deviceId)">
                                <span>{{ formatTime(getLatestLogbookEntry(row.item.ship.deviceId).time) }}</span>
                                <br>
                                <span>{{ formatPosition(getLatestLogbookEntry(row.item.ship.deviceId).pos) }}</span>
                                <br>
                                <span>SOG: {{ getLatestLogbookEntry(row.item.ship.deviceId).sog }}</span>
                                ,
                                <span>COG: {{ getLatestLogbookEntry(row.item.ship.deviceId).cog }}</span>
                                ,
                                <span>HDG: {{ getLatestLogbookEntry(row.item.ship.deviceId).hdg }}</span>
                                <template v-if="countLogbookMessages(row.item.ship.deviceId) > 0">
  <br>
                                  {{ countLogbookMessages(row.item.ship.deviceId) }} messages
                                  <b-link href="#" @click.prevent="showLatestLogbookDetails(row.item.ship.deviceId)">
                                    more...
                                  </b-link>
</template>
                              </template>
                              <template v-else>
No logbook data
</template>
                            </dd>
                          </div>

                          <hr>

                          <div>
                            <dt>Weather</dt>
                            <dd>
                              <template v-if="fleetStore.weather && fleetStore.weather[row.item.ship.deviceId]">
  <span>Wind: {{ fleetStore.weather[row.item.ship.deviceId].wind }} m/s</span>
                                ,
                                <span>Angle: {{ fleetStore.weather[row.item.ship.deviceId].windAngle }}°</span>
                                ,
                                <span>Temperature: {{ fleetStore.weather[row.item.ship.deviceId].temperature }}°C</span>
                                <template v-if="fleetStore.weather[row.item.ship.deviceId].timestamp">
                                  (Updated: {{ formatWeatherTime(fleetStore.weather[row.item.ship.deviceId].timestamp) }})
                                </template>
</template>
                              <template v-else>
  No weather data
</template>
                            </dd>
                          </div>

                          <div v-if="row.item.status === 2">
                            <dt>{{ $t('fleet.status') }}</dt>
                            <dd>{{ $t('fleet.noMapsForRoute') }}</dd>
                          </div>

                          <hr>

                          <div>
                            <dt>{{ $t('fleet.imo') }}</dt>
                            <dd>
                              {{ row.item.ship.imo }} (
                              <b-link href="#" @click.prevent="editShip(row.item.ship)">
                                {{ $t('fleet.edit') }}
                              </b-link>
                              )
                            </dd>
                          </div>

                          <div>
                            <dt>{{ $t('fleet.deviceid') }}</dt>
                            <dd>{{ row.item.ship.deviceId }}</dd>
                          </div>
                        </div>
                      </template>
                    </b-table>
                  </div>
                  <div v-else class="empty-ships-message">
                    <b-alert show variant="info" class="d-flex align-items-center">
                      <i class="fas fa-info-circle mr-2" />
                      {{ $t('fleet.pressToAddShip') }}
                      <b-button variant="link" class="ml-2" @click="addShip()">
                        <i class="fas fa-plus-circle" />
                        {{ $t('fleet.addShip') }}
                      </b-button>
                    </b-alert>
                  </div>
                </div>
              </b-col>

              <b-col v-show="!isMobile || activeMobileView === 'map'" order="4" order-lg="1" lg="8">
                <b-row>
                  <b-col class="text-left">
                    <div class="d-flex align-items-center">
                      <div class="ship-badge">
                        <!-- <i class="fas fa-ship mr-2" /> -->
                        <span>{{ getShipName }}</span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <home-map ref="homemap" :map="map" :height="map_size" :style="{ height: map_size + 'px' }" @map-destroyed="onMapDestroyed" />
                  </b-col>
                </b-row>
            </b-col>                
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </loading-indicator>
  </div>
</template>

<script>
import HomeMap from '@/views/home/HomeMap.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import { eventBus, home_map } from '@/main'
import { mapStores } from 'pinia'
import { useRoutesStore } from '@/stores/routes'
import { useLogbookStore } from '@/stores/logbook'
import { useFleetStore } from '@/stores/fleet'
import AlertsModal from '@/views/home/modals/AlertsModal.vue'
import AlertsSubscribeModal from '@/views/home/modals/AlertsSubscribeModal.vue'
import LogbookModal from '@/views/home/modals/LogbookModal.vue'
import OrdersModal from '@/views/home/modals/OrdersModal.vue'
import FolioModal from '@/views/home/modals/FolioModal.vue'
import WeatherModal from '@/views/home/modals/WeatherModal.vue'
import DeliveriesModal from '@/views/home/modals/DeliveriesModal.vue'
import AgreementModal from '@/views/home/modals/AgreementModal.vue'
import AddShipModal from '@/views/home/modals/AddShipModal.vue'
import { useDeviceStore } from '@/stores/device'
import { useUserStore } from '@/stores/user'
import router from '@/router'
import { useMomentaryStore } from '@/stores/momentary'
import { myAxios } from '@/services/myAxios'
import HomeEcdis from '@/views/home/HomeEcdis.vue'
import QRScannerDialog from '@/components/qrreader/QRScannerDialog.vue'
import { loadJSON } from '@/utils/utils'
import memoryMonitor from '@/utils/memory-monitor'
import {
  loadFleetInstallations,
  loadFleetTransactions,
  loadFleetAgreements,
  loadFleetLogbook,
  loadFleetFolio,
  loadFleetDeliveries,
  loadAllShipsAISDataAndDraw,
  loadWeather,
  checkAllShipsFolios,
  loadNavarea,
  loadQrServiceCode
} from '../../helpers/apiFleet'
import { loadPorts } from '../../helpers/apiFleet'

export default {
  components: {
    HomeEcdis,
    HomeMap,
    LoadingIndicator,
    QRScannerDialog,
    AlertsModal,
    AlertsSubscribeModal,
    LogbookModal,
    OrdersModal,
    WeatherModal,
    FolioModal,
    AddShipModal,
    AgreementModal,
    DeliveriesModal
  },
  data() {
    return {
      openedDetailIndex: null,
      navareaData: null,
      selected_ship: '',
      selected_row: null,
      ships: [],
      windowWidth: window.innerWidth,
      map: home_map, // Карта уже инициализирована в main.js
      mapHeight: window.innerHeight - 200, // Высота карты для десктопа
      mapHeightMobile: window.innerHeight - 130, // Высота карты для мобильных устройств
      isFleetLoading: false,
      activeMobileView: 'table', // Активный вид для мобильных устройств (таблица или карта)

      // модальные окна
      modalOrders: [],
      modalFolioData: [],
      modalAlerts: [],
      modalAlertsSubscribe: [],
      modalDeliveries: [],
      modalAgreementData: null,
      modalLogbookData: null,
      modalWeatherData: {},

      qrCodeUrl: null, // Для хранения URL QR-кода

      shipTableFields: [{ key: 'summary', label: '' }],

      // для поиска
      showSearchBar: false, // Показывать ли строку поиска
      searchQuery: '', // Поисковый запрос
      filteredItems: null // Отфильтрованные элементы
    }
  },
  watch: {
    // Отслеживаем изменения выбранного корабля
    selected_ship(newVal) {
      console.log('Selected ship changed:', newVal)
      // Находим данные корабля и договора
      const fleet = this.fleetStore.getFleet || []
      const selectedShip = fleet.find(ship => ship.ship.deviceId === newVal)
      const agreement = this.findAgreementByDeviceId(newVal)

      // Используем новый метод для сохранения всех данных
      console.log('Selected ship details:', selectedShip, agreement)
      this.deviceStore.selectDeviceWithDetails(newVal, selectedShip?.ship?.name, agreement)

      this.$refs['logbook-report']?.changeShip()
      this.$refs['logbook-table']?.loadLogbook()
    },
    activeMobileView(newVal) {
      if (newVal === 'map') {
        this.$nextTick(() => {
          this.$refs.homemap.invalidateSize()
        })
      }
    }
  },
  async mounted() {
    // Мониторинг памяти: начальная точка
    memoryMonitor.takeSnapshot('home-mounted-start')

    // Проверка доступности API
    myAxios.get('/api/v1/manage/test')

    // Добавляем обработчик изменения размера окна
    window.addEventListener('resize', this.handleResize)

    // Отрисовываем маршрут на карте, если есть путевые точки
    // if (this.routesStore.getShipWaypointsCount > 0)
    //   this.map.drawRoute()

    // Восстанавливаем отметки из логбука на карте, если есть записи в судовом журнале
    if (this.logbookStore.logbook.length > 0) this.map.restoreReports()

    // const momentaryStore = useMomentaryStore();

    // // Проверяем, показывается ли сплэш-скрин
    // if (momentaryStore.getShowSplashFlag) {
    //   const unwatchSplash = this.$watch(
    //       () => momentaryStore.getShowSplashFlag,
    //       (newVal) => {
    //         if (!newVal) {
    //           this.isLoading = true;
    //           unwatchSplash(); // Удаляем наблюдатель после первого срабатывания
    //
    //           this.loadLayers().then(( =))
    //           this.loadFleetData();
    //         }
    //       }
    //   );
    // } else {

    memoryMonitor.takeSnapshot('home-before-load-layers')
    await this.loadLayers()
    memoryMonitor.takeSnapshot('home-after-load-layers')

    await this.$refs.homemap.initMap()
    memoryMonitor.takeSnapshot('home-after-init-map')

    this.loadFleetData()
    memoryMonitor.takeSnapshot('home-after-load-fleet')

    // Временный вывод списка IMO кораблей в консоль
    this.$nextTick(() => {
      console.log('Список IMO кораблей:', this.tableItems.map(item => item.ship.imo))
    })

    eventBus.$on('scan-info-success', () => {
      console.log('QR scan successful, refreshing fleet data...');
      // Обновляем данные после успешного сканирования QR кода
      this.refreshData();
    })

    // Обработчики событий для обновления данных после регистрации/редактирования корабля
    eventBus.$on('ship-registered', () => {
      console.log('Ship registered, refreshing fleet data...');
      this.refreshData();
    });

    eventBus.$on('ship-updated', () => {
      console.log('Ship updated, refreshing fleet data...');
      this.refreshData();
    });

    // Обработчик для закрытия модальных окон
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      switch (modalId) {
        case 'orders-modal':
          this.clearModalData('orders-modal')
          break
        case 'weather-modal':
          this.clearModalData('weather-modal')
          break
        case 'folio-modal':
          this.clearModalData('folio-modal')
          break
        case 'logbook-modal':
          this.clearModalData('logbook-modal')
          break
        case 'alerts-modal':
          this.clearModalData('alerts-modal')
          break
        case 'deliveries-modal':
          this.clearModalData('deliveries-modal')
          break
      }
    })

    // Обработчик для выбора корабля
    eventBus.$on('select-ship', deviceId => {
      if (!deviceId) return

      // Ищем корабль в таблице
      const fleet = this.fleetStore.getFleet || []
      const index = fleet.findIndex(item => item && item.ship && item.ship.deviceId === deviceId)

      if (index >= 0) {
        // Выбираем корабль в таблице для отображения деталей
        this.toggleDetails(index, deviceId, true)

        // Прокручиваем к выбранному кораблю
        this.$nextTick(() => {
          const shipRow = document.querySelector(`tr[data-device-id="${deviceId}"]`)
          if (shipRow) {
            shipRow.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
      }
    })
  },
  beforeDestroy() {
    // Мониторинг памяти: начало очистки
    memoryMonitor.takeSnapshot('home-destroy-start')

    // Принудительно очищаем карту и освобождаем память (только если карта еще не была очищена)
    if (this.map) {
      try {
        this.map.destroy()
        memoryMonitor.takeSnapshot('home-after-map-destroy')
      } catch (error) {
        console.warn('Error cleaning map in index.vue:', error)
      } finally {
        // В любом случае обнуляем ссылку
        this.map = null
      }
    }

    // Отключаем все event listeners
    eventBus.$off('select-ship')
    eventBus.$off('scan-info-success')
    eventBus.$off('ship-registered')
    eventBus.$off('ship-updated')
    // eventBus.$off('close-aio-popup')
    // eventBus.$off('highlight-aio-on-map');
    // eventBus.$off('clear-aio-highlight');

    window.removeEventListener('resize', this.handleResize)

    // Очиститка интервалов
    if (this.logbookRefreshInterval) {
      clearInterval(this.logbookRefreshInterval)
      this.logbookRefreshInterval = null
    }

    // Очищаем все модальные данные и освобождаем память
    this.modalOrders = []
    this.modalFolioData = []
    this.modalAlerts = []
    this.modalAlertsSubscribe = []
    this.modalDeliveries = []
    this.modalLogbookData = null
    this.modalWeatherData = {}
    this.modalAgreementData = null

    // Очищаем данные о кораблях и фильтрации
    this.ships = []
    this.filteredItems = null
    this.selected_ship = ''
    this.selected_row = null
    this.openedDetailIndex = null

    // Очищаем QR код URL если он был создан
    if (this.qrCodeUrl) {
      try {
        URL.revokeObjectURL(this.qrCodeUrl)
      } catch (e) {
        // Игнорируем ошибки освобождения URL
      }
      this.qrCodeUrl = null
    }

    // Принудительная очистка памяти в хранилище
    try {
      if (this.fleetStore && this.fleetStore.forceCleanupMemory) {
        this.fleetStore.forceCleanupMemory()
      }
    } catch (error) {
      console.warn('Error force clearing storage memory:', error)
    }

    this.$root.$off('bv::modal::hidden')

    // Мониторинг памяти: конец очистки
    memoryMonitor.takeSnapshot('home-destroy-end')

    // В development режиме показываем статистику памяти
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        memoryMonitor.diff('home-mounted-start', 'home-destroy-end')
      }, 100)
    }
  },
  computed: {
    ...mapStores(useMomentaryStore, useRoutesStore, useLogbookStore, useUserStore, useDeviceStore, useFleetStore),
    isMobile() {
      return this.windowWidth < 768
    },
    map_size() {
      if (this.isMobile) {
        return this.mapHeightMobile
      } else {
        const headerOffset = 120
        return window.innerHeight - headerOffset
      }
    },
    getShipName() {
      if (this.selected_ship === "") return "No selected ship";
      return this.fleetStore.getShipName(this.selected_ship);
    },

    tableItems() {
      return this.filteredItems || this.fleetStore.getFleet || []
    }
  },
  methods: {
    // Показываем модальное окно с QR-кодом
    async showQRServiceCode() {
      this.qrCodeUrl = null // Сбрасываем предыдущий QR-код
      this.$bvModal.show('qr-code-modal') // Показываем модальное окно
      const qrUrl = await loadQrServiceCode()
      if (qrUrl) {
        this.qrCodeUrl = qrUrl
      } else {
        // Можно добавить обработку ошибок, например, показать сообщение
        this.$bvModal.hide('qr-code-modal')
        // TODO: показать ошибку пользователю
      }
    },

    // Обработчик события уничтожения карты из дочернего компонента
    onMapDestroyed() {
      // Обнуляем ссылку на карту в родительском компоненте
      this.map = null
    },

    handleResize() {
      this.windowWidth = window.innerWidth
      this.$forceUpdate()
    },

    // Загружаем порты, навареа, aio
    async loadLayers() {
      // this.momentaryStore.startCriticalLoading('loadLayers', 'Loading map layers...');

      try {
        const result = await Promise.all([loadNavarea(), loadPorts()])
        return result
      } finally {
        // this.momentaryStore.stopLoading('loadLayers');
      }
    },

    // Загружает все данные и рисует корабли на карте
    loadFleetData() {
      let dataAlreadyLoaded = this.fleetStore.hasInstallations
      if (dataAlreadyLoaded) {
        this.drawShipsOnMap()
        return
      }

      this.momentaryStore.startCriticalLoading('loadFleetData', this.$t('general.loadingFleetData', 'Loading fleet data...'))

      Promise.all([loadFleetInstallations(), loadFleetAgreements()])
        .then(() => {
          this.momentaryStore.stopCriticalLoading('loadFleetData')

          // Запускаем загрузку AIS данных в фоне
          this.momentaryStore.startBackgroundLoading('loadAISData', 'Loading AIS data...')
          this.momentaryStore.startBackgroundLoading('loadTransactions', 'Loading transactions...')

          loadFleetTransactions(false, true).then(() => {
            this.momentaryStore.stopBackgroundLoading('loadTransactions')
          })

          loadAllShipsAISDataAndDraw().then(() => {
            this.momentaryStore.stopBackgroundLoading('loadAISData')
            console.log('[DEBUG] loadAllShipsAISDataAndDraw completed')
            console.log('[DEBUG] fleetStore.AISData after load:', this.fleetStore.AISData)
            console.log('[DEBUG] AISData keys after load:', Object.keys(this.fleetStore.AISData))
            // Отрисовываем корабли после завершения загрузки AIS данных
            this.drawShipsOnMap()
          })

          // Удаляем setTimeout, так как теперь отрисовка происходит в then() выше

          // Сохраняем deviceId первого элемента из fleetStore, чтобы сработал автоматический выбор корабля
          const firstFleetItem = this.fleetStore.getFleet?.[0]
          if (firstFleetItem?.ship?.deviceId)
            this.deviceStore.selectDevice(firstFleetItem.ship.deviceId)

          if (this.deviceStore.isDeviceIDExist)
            this.selected_ship = this.deviceStore.getDeviceID
          else
            this.selected_ship = this.userStore.getECDISShips[0]?.value ?? ''

          this.ships = this.userStore.getECDISShips
        })
        .catch(error => {
          console.error('Error loading fleet data:', error)
        })
        .finally(() => {
          // this.momentaryStore.stopCriticalLoading('loadFleetData');
          // this.momentaryStore.stopBackgroundLoading('loadAISData');
        })
    },

    refreshData() {
      this.momentaryStore.startCriticalLoading('refreshData', 'Refreshing data...')
      this.openedDetailIndex = null

      Promise.all([loadFleetInstallations(true), loadFleetAgreements(true)])
        .then(() => {
          this.momentaryStore.stopCriticalLoading('refreshData')

          // Запускаем загрузку транзакций в фоне
          this.momentaryStore.startBackgroundLoading('refreshTransactions', 'Loading transactions...')
          loadFleetTransactions(true, true).then(() => {
            this.momentaryStore.stopBackgroundLoading('refreshTransactions')
          })

          if (this.deviceStore.isDeviceIDExist) {
            const deviceId = this.deviceStore.getDeviceID
            // Загружаем дополнительные данные в фоне
            this.momentaryStore.startBackgroundLoading('refreshDeviceData', 'Updating device data...')
            return Promise.all([loadFleetLogbook(deviceId, true), loadFleetDeliveries(deviceId, '2024-12-06T10:16:06.695Z', true), loadFleetFolio(deviceId, true)]).finally(() => {
              this.momentaryStore.stopBackgroundLoading('refreshDeviceData')
            })
          }
        })
        .then(() => {
          this.drawShipsOnMap()
        })
        .catch(error => {
          console.error('Error refreshing data:', error)
        })
    },

    hasAlert(deviceId, type) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля в alerts
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        return false
      }

      // Ищем записи типа "Wind/NavArea" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === type)

      if (windAlerts.length === 0) {
        return false
      }

      const windAlert = windAlerts[0]

      // Определяем опасный ли ветер
      switch (windAlert.color) {
        case 'Red':
          return true
        case 'Yellow':
          return true
        default:
          return false
      }
    },

    getAlertText(deviceId, type) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля в alerts
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        return 'not available'
      }

      // Ищем записи типа "Wind/NavArea" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === type)

      if (windAlerts.length === 0) {
        return 'not available'
      }

      return windAlerts[0].texts.join('\n')
    },

    getWeatherIconClass(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля в alerts
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        return 'text-secondary' // серый цвет если нет данных
      }

      // Ищем записи типа "Wind" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'Wind')

      if (windAlerts.length === 0) {
        return 'text-secondary' // серый цвет если нет данных о ветре
      }

      // Берем первую запись о ветре
      const windAlert = windAlerts[0]

      // Определяем цвет на основе поля color
      switch (windAlert.color) {
        case 'Red':
          return 'text-danger' // красный
        case 'Yellow':
          return 'text-warning' // желтый
        case 'Green':
          return 'text-success' // зеленый
        case 'NoColor':
        default:
          return 'text-secondary' // серый
      }
    },

    howWeatherData(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        this.$bvToast.toast('No weather data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Ищем записи типа "Wind" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'Wind')

      if (windAlerts.length === 0) {
        this.$bvToast.toast('No wind data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Находим корабль для получения имени
      const ship = fleetStore.getFleet.find(s => s.ship.deviceId === deviceId)

      // Формируем данные для модального окна на основе alerts
      this.modalWeatherData = {
        [deviceId]: {
          shipName: ship?.ship?.name || deviceId,
          alerts: windAlerts, // передаем все записи о ветре
          // Для совместимости с существующим модальным окном можем добавить:
          wind: windAlerts[0]?.text || 'Нет данных',
          timestamp: new Date().toISOString()
        }
      }

      this.$bvModal.show('weather-modal')
    },

    loadWeatherForAllShips() {
      const { fleetStore } = this

      if (fleetStore.AISData && Object.keys(fleetStore.AISData).length > 0) {
        const promises = []

        Object.keys(fleetStore.AISData).forEach(deviceId => {
          const aisData = fleetStore.AISData[deviceId]
          if (aisData && aisData.lat && aisData.lon) {
            promises.push(loadWeather(deviceId, true))
          }
        })

        if (promises.length > 0) {
          Promise.all(promises)
            .then(() => { })
            .catch(error => {
              console.error('Error loading weather data:', error)
            })
        }
      }
    },

    formatWeatherTime(timestamp) {
      if (!timestamp) return ''
      return new Date(timestamp * 1000).toLocaleString()
    },

    // Сворачиваем все детали
    collapseAllDetails() {
      if (this.openedDetailIndex !== null && this.openedDetailIndex >= 0) {
        const fleet = this.fleetStore.getFleet
        if (fleet && Array.isArray(fleet) && fleet.length > this.openedDetailIndex && fleet[this.openedDetailIndex]) {
          // Устанавливаем флаг _showDetails в false
          this.$set(fleet[this.openedDetailIndex], '_showDetails', false)

          if (this.$refs.fleetTable && this.$refs.fleetTable.toggleDetails) {
            this.$refs.fleetTable.toggleDetails(this.openedDetailIndex)
          }
        }

        this.openedDetailIndex = null
        this.selected_ship = ''
      }
    },

    formatETA(etaString) {
      if (!etaString) return 'N/A'
      const date = new Date(etaString)
      return date.toLocaleString()
    },

    clearModalData(modalName) {
      switch (modalName) {
        case 'orders-modal':
          this.modalOrders = []
          break
        case 'weather-modal':
          this.modalWeatherData = {}
          break
        case 'folio-modal':
          this.modalFolioData = []
          break
        case 'logbook-modal':
          this.modalLogbookData = null
          break
        case 'alerts-modal':
          this.modalAlerts = []
          break
        case 'alerts-subscribe-modal':
          this.modalAlertsSubscribe = []
          break
        case 'deliveries-modal':
          this.modalDeliveries = []
          break
      }
    },
    // Отрисовываем все корабли у которых есть позиция на карте
    drawShipsOnMap() {
      const { fleetStore } = this

      console.log('[DEBUG] drawShipsOnMap called')
      console.log('[DEBUG] fleetStore.AISData:', fleetStore.AISData)
      console.log('[DEBUG] fleetStore.AISData keys:', Object.keys(fleetStore.AISData))
      console.log('[DEBUG] getFleet length:', fleetStore.getFleet?.length || 0)

      if (fleetStore.AISData && Object.keys(fleetStore.AISData).length > 0) {
        // Собираем позиции кораблей с AIS данными
        const shipPositions = []

        const fleetShips = fleetStore.getFleet || []

        // Итерируемся по всем кораблям
        fleetShips.forEach(fleetShip => {
          const deviceId = fleetShip.ship.deviceId
          const aisData = fleetStore.AISData[deviceId]

          // Проверяем, есть ли AIS данные и координаты (в разных местах структуры)
          let hasValidPosition = false
          let shipLat = null
          let shipLon = null

          if (aisData) {
            // Проверяем координаты в основной структуре (старый формат)
            if (aisData.lat && aisData.lon) {
              hasValidPosition = true
              shipLat = aisData.lat
              shipLon = aisData.lon
            }
            // Проверяем координаты в payload.Position (новый формат)
            else if (aisData.payload && aisData.payload.Position && 
                     aisData.payload.Position.lat && aisData.payload.Position.lon) {
              hasValidPosition = true
              shipLat = aisData.payload.Position.lat
              shipLon = aisData.payload.Position.lon
            }
          }

          if (hasValidPosition) {
            // Флаг, что данные AIS устарели
            const isOldData = this.isAISDataOld(deviceId)

            shipPositions.push({
              value: deviceId, // уникальный идентификатор корабля
              name: fleetShip.ship.name || 'Unknown ship',
              imo: fleetShip.ship.imo || 'Unknown IMO',
              position: {
                lat: shipLat,
                lon: shipLon
              },
              aisCOG: aisData.payload?.CourseOverGround || 0,
              aisStatus: this.getAISStatus(deviceId),
              speed: aisData.speedKnots || (aisData.payload?.SpeedOverGround?.Knots) || 0,
              destination: aisData.destination || aisData.payload?.Destination || 'Unknown',
              eta: aisData.eta || '',
              time: aisData.time || new Date().toISOString(),
              isOldData: isOldData
            })
          }
        })

        // Если есть позиции кораблей, рисуем их на карте
        this.map.drawShips(shipPositions, this.selected_ship)
      } else {
        console.log('No AIS data available for drawing ships on map')
      }
    },

    // Проверяем, насколько устарели данные по AIS по deviceId
    isAISDataOld(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.time) return false

      const aisTime = new Date(aisData.time)
      const currentTime = new Date()

      const hoursDifference = (currentTime - aisTime) / (1000 * 60 * 60)

      // Данные устарели если прошло более 10 часов
      return hoursDifference > 10
    },

    // Проверяем наличие карт в фолио корабля по deviceId
    hasDeviceFolioData(deviceId) {
      if (!this.fleetStore.folio) return false
      const deviceFolioItems = this.fleetStore.folio.filter(item => item.deviceId === deviceId && item.isPaid === true)

      return deviceFolioItems.some(folioItem => folioItem.items && folioItem.items.length > 0)
    },

    // Получаем количество данных определенного типа в фолио корабля (например, карты S63, AVCS и т.д.) по deviceId
    countItemsByType(deviceId, itemType) {
      if (!this.fleetStore.folio) return 0

      // Список всех купленных данных
      const deviceFolioItems = this.fleetStore.folio.filter(item => item.deviceId === deviceId && item.isPaid === true && item.status === 'complete')

      // Считаем количество данных определенного типа
      let count = 0
      deviceFolioItems.forEach(folioItem => {
        if (folioItem.items && folioItem.items.length) {
          count += folioItem.items.filter(item => item.type === itemType).length
        }
      })

      return count
    },

    // Получаем заказы корабля по deviceId
    getShipOrders(deviceId) {
      const orders = this.fleetStore.transactions || []
      return orders.filter(order => order.device && order.device.deviceId === deviceId)
    },

    getLatestOrder(deviceId) {
      const orders = this.getShipOrders(deviceId)
      if (orders.length === 0) return null

      // Sort by updatedAt in descending order (newest first)
      return orders.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0]
    },

    // Форматируем дату заказа
    formatOrderDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString()
    },

    // Получаем цену заказа с валютой
    getOrderPrice(order) {
      if (!order || !order.price) return ''
      return `${order.price.price} ${order.price.currency}`
    },

    // TODO
    hasPaidFolioItems(deviceId) {
      // eslint-disable-next-line no-unused-vars
      const _ = deviceId // Temporarily unused until implementation is complete
      return false
      // if (!this.fleetStore.folio) return false;
      // return this.fleetStore.folio.some(item => item.deviceId === deviceId && item.isPaid === true && item.status === 'complete');
    },

    // Получаем оплаченные данные фолио для корабля по deviceId
    getPaidFolioItems(deviceId) {
      if (!this.fleetStore.folio) return []
      return this.fleetStore.folio.filter(item => item.deviceId === deviceId && item.isPaid === true && item.status === 'complete')
    },

    // Получаем последние записи из логбука для корабля по deviceId
    getLatestLogbookEntry(deviceId) {
      if (!this.fleetStore.logbook) return null

      // Логи с экдиса
      const ecdisLogs = this.fleetStore.logbook.ecdis?.filter(msg => msg.deviceId === deviceId) || []

      // Логи из веб-интерфейса
      const webLogs = this.fleetStore.logbook.web?.filter(msg => msg.deviceId === deviceId) || []

      // Объединяем логи из ECDIS и Web и сортируем их по времени (новейшие первыми)
      const combinedLogs = [...ecdisLogs, ...webLogs].sort((a, b) => new Date(b.time) - new Date(a.time))

      // Возвращаем самый последний лог если есть
      return combinedLogs.length ? combinedLogs[0] : null
    },

    // Получаем количество сообщений в логбуке для корабля по deviceId
    countLogbookMessages(deviceId) {
      if (!this.fleetStore.logbook) return 0

      const ecdisCount = this.fleetStore.logbook.ecdis?.filter(msg => msg.deviceId === deviceId).length || 0

      const webCount = this.fleetStore.logbook.web?.filter(msg => msg.deviceId === deviceId).length || 0

      return ecdisCount + webCount
    },

    // Форматируем время для отображения
    formatTime(timeString) {
      if (!timeString) return ''
      const date = new Date(timeString)
      return date.toLocaleString()
    },

    // Форматируем позицию для отображения
    formatPosition(pos) {
      if (!pos) return ''
      if (pos && pos.lat && pos.lon) {
        // Округляем координаты до 6 знаков после запятой
        const lat = parseFloat(pos.lat).toFixed(6)
        const lon = parseFloat(pos.lon).toFixed(6)
        return `${lat}, ${lon}`
      }
      return this.$t('general.noPosition', 'no position')
    },

    // Показываем детали логбука в модальном окне
    showLatestLogbookDetails(deviceId) {
      if (!this.fleetStore.logbook) return

      // Логи с экдиса
      const ecdisLogs = this.fleetStore.logbook.ecdis?.filter(msg => msg.deviceId === deviceId) || []

      // Логи из веб-интерфейса
      const webLogs = this.fleetStore.logbook.web?.filter(msg => msg.deviceId === deviceId) || []

      // Объединяем логи из ECDIS и Web
      const combinedLogs = [...ecdisLogs, ...webLogs]

      if (combinedLogs.length === 0) return

      // Сортируем логи по времени (новейшие первыми)
      const sortedLogs = combinedLogs.sort((a, b) => new Date(b.time) - new Date(a.time))

      // Получаем самый последний лог
      const latestEntry = sortedLogs[0]

      // Формируем данные для отображения в логбуке
      const logbookData = {
        time: this.formatTime(latestEntry.time),
        position: this.formatPosition(latestEntry.pos),
        spd: latestEntry.sog,
        cog: latestEntry.cog,
        hdg: latestEntry.hdg,
        route: latestEntry.route || 'Unknown',
        messages: sortedLogs.map(msg => ({
          time: this.formatTime(msg.time),
          type: msg.source || (msg.isEcdis ? 'ecdis' : 'web'),
          position: this.formatPosition(msg.pos),
          message: msg.message
        }))
      }

      this.showLogbookDetails(logbookData)
    },

    // Получаем отгрузки
    getShipDeliveries() {
      return useFleetStore().deliveries
    },

    // Получаем последнюю отгрузку
    getLatestDelivery() {
      const deliveries = this.getShipDeliveries()
      return deliveries.length > 0 ? deliveries[0] : null
    },

    // Получаем дату отгрузки в читаемом формате
    formatDeliveryDate(delivery) {
      if (!delivery || !delivery.timestamp) return ''
      const date = new Date(delivery.timestamp)
      return date.toLocaleString()
    },

    // TODO
    getStatusVariant(status) {
      switch (status) {
        case 'in transit':
          return 'success'
        case 'anchored':
          return 'danger'
        case 'berthed':
        case 'unknown':
          return 'secondary'
        default:
          return 'info'
      }
    },

    // Этот корабль принадлежит пользователю?
    isOwnShip(shipEmail) {
      return shipEmail === this.$store.state.auth.user.email
    },

    // Получаем цвет для отображения договора
    getAgreementVariant(deviceId, agreementName) {
      if (!agreementName) return 'secondary'

      // Находим договор по deviceId
      const agreement = this.findAgreementByDeviceId(deviceId)

      if (!agreement) return 'warning'

      // Проверяем срок действия договора
      const validTill = agreement.validTill
      if (!validTill) return 'warning'

      const now = new Date()
      const expiryDate = new Date(validTill)

      return expiryDate < now ? 'danger' : 'success'
    },

    // Находим договор по deviceId
    findAgreementByDeviceId(deviceId) {
      if (!this.fleetStore.agreements || !this.fleetStore.agreements.length) return null

      // Ищем договор, в котором есть устройство с данным deviceId
      for (const agreement of this.fleetStore.agreements) {
        // Проверяем, есть ли в пользователях договора устройство с данным deviceId
        if (agreement.users && agreement.users.some(user => user.deviceId === deviceId)) {
          return agreement
        }
      }
      return null
    },

    // Показываем детали договора в модальном окне
    showAgreementDetails(deviceId, agreementName) {
      // Находим договор по deviceId
      const agreement = this.findAgreementByDeviceId(deviceId)

      if (agreement) {
        this.modalAgreementData = agreement
        this.$bvModal.show('agreement-modal')
      } else {
        // Если договор не найден, показываем данные по умолчанию
        this.modalAgreementData = null
        this.$bvModal.show('agreement-modal')
      }
    },

    // Получаем цвет статуса AIS для отображения
    getAISStatusVariant(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      const status = this.getAISStatus(deviceId)
      
      // Если AIS данные есть и статус известен (не "no position" и не "unknown")
      if (aisData && aisData.payload && aisData.payload.NavigationStatus && 
          status !== 'no position' && status !== 'unknown') {
        return 'success'
      }
      // Если данные AIS отсутствуют или статус неизвестен
      return 'secondary'
    },

    // Форматируем время AIS для отображения
    formatAISTime(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.time) return ''

      const date = new Date(aisData.time)

      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month} ${hours}:${minutes}`
    },

    // Получаем цвет статуса AIS с учетом времени
    getAISTimeBasedVariant(deviceId) {
      // Получаем стандартный цвет статуса AIS
      const statusVariant = this.getAISStatusVariant(deviceId)

      // Если статус неизвестен, возвращаем стандартный цвет
      if (this.getAISStatus(deviceId) === 'unknown') {
        return statusVariant
      }

      // Проверяем время AIS данных
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.time) return statusVariant

      const aisTime = new Date(aisData.time)
      const currentTime = new Date()

      // Вычисляем разницу в часах между текущим временем и временем AIS данных
      const hoursDifference = (currentTime - aisTime) / (1000 * 60 * 60)

      // Если данные AIS устарели более 10 часов, возвращаем желтый цвет
      if (hoursDifference > 10) {
        return 'warning'
      }

      // Если данные AIS свежие, возвращаем стандартный цвет статуса
      return statusVariant
    },

    // Получаем текстовое описание статуса AIS по deviceId
    getAISStatus(deviceId) {
      const aisData = this.fleetStore.AISData[deviceId]
      if (!aisData || !aisData.payload || !aisData.payload.NavigationStatus) {
        return this.$t('general.noPosition', 'no position')
      }

      // Получаем статус навигации из AIS данных
      const statusCode = aisData.payload.NavigationStatus
      
      // Если статус уже в текстовом формате (из кэша), возвращаем как есть
      if (typeof statusCode === 'string' && isNaN(statusCode)) {
        return statusCode.toLowerCase()
      }
      
      // Расшифровываем числовой код статуса навигации из AIS данных
      switch (statusCode) {
        case '0':
          return 'under way using engine'
        case '1':
          return 'at anchor'
        case '2':
          return 'not under command'
        case '3':
          return 'restricted maneuverability'
        case '4':
          return 'constrained by draft'
        case '5':
          return 'moored'
        case '6':
          return 'aground'
        case '7':
          return 'engaged in fishing'
        case '8':
          return 'under way sailing'
        case '9':
          return 'reserved for HSC'
        case '10':
          return 'reserved for WIG'
        case '11':
          return 'reserved'
        case '12':
          return 'reserved'
        case '13':
          return 'reserved'
        case '14':
          return 'AIS-SART active'
        case '15':
          return 'undefined'
        default:
          return 'unknown'
      }
    },

    // Показываем детали заказов в модальном окне
    showOrderDetails(orders) {
      this.$bvModal.show('orders-modal')
      this.modalOrders = orders
    },

    // Показываем детали фолио в модальном окне
    showFolioDetails(paidItems) {
      this.modalFolioData = paidItems
      this.$bvModal.show('folio-modal')
    },

    // Показываем детали отгрузок в модальном окне
    showShipDeliveries() {
      this.modalDeliveries = this.getShipDeliveries()
      this.$bvModal.show('deliveries-modal')
    },

    // Показываем детали логбука в модальном окне
    showLogbookDetails(logbookData) {
      this.modalLogbookData = logbookData
      this.$bvModal.show('logbook-modal')
    },

    // Нажата кнопка добавления корабля
    addShip() {
      this.$bvModal.show('add-ship-modal')
      eventBus.$emit('clean-ship-form')
    },

    // Нажата кнопка редактирования корабля
    editShip(ship) {
      this.$root.$emit('bv::toggle::collapse', 'ship-edit')
      eventBus.$emit('clean-ship-form')

      this.$nextTick(() => {
        console.log('SHIP', ship)

        eventBus.$emit('populate-ship-form', {
          user_email: ship.emails,
          ship_appid: ship.applicationId,
          ship_name: ship.name,
          ship_imo: ship.imo,
          ship_mmsi: ship.mmsi,
          permit_main: ship.upn1,
          permit_backup: ship.upn2,
          permit_backup2: ship.upn3,
          ship_w: ship.width,
          ship_l: ship.length,
          ship_h: ship.height,
          ship_d: ship.draught,
          ecdis_os: ship.ecdisOs,
          ecdis_brand: ship.ecdisBrand,
          ship_country: ship.flag,
          ship_callsign: ship.call,
          ship_category: ship.category,

          is_edit: true,
          deviceId: ship.deviceId
        })
      })
    },

    // Обработчик клика по строке таблицы
    handleRowClick(item, index) {
      const deviceId = item.ship.deviceId

      // Проверяем, что детали уже открыты
      const isCurrentlyOpen = this.openedDetailIndex === index

      // Возвращаем цвет всем ранее открытым ячейкам
      this.clearAllHighlightedCells()

      // Если кликнули по уже открытой строке - сворачиваем все детали
      if (isCurrentlyOpen) {
        this.collapseAllDetails()
        return
      }

      // Иначе - раскрываем детали
      this.toggleDetails(index, deviceId, true)

      // Позицинируем карту к выбранному кораблю
      if (this.map && deviceId && this.fleetStore.AISData && this.fleetStore.AISData[deviceId]) {
        this.map.setSelectedShip(deviceId)

        // В мобильном виде автоматически переключаемся на карту
        // if (this.isMobile) {
        //   this.activeMobileView = 'map';
        // }
      }
    },

    // Возвращаем цвет заголовков ранее раскрытых ячеек
    clearAllHighlightedCells() {
      // Clear all highlighted cells
      const allHighlightedCells = document.querySelectorAll('.ship-table td.selected-header')
      allHighlightedCells.forEach(cell => {
        cell.classList.remove('selected-header')
        cell.style.backgroundColor = ''
      })
    },

    // Устанавливаем дополнительные аттрибуты для строки таблицы
    rowAttributes(item, type) {
      // Set attributes for each row in the table
      if (type === 'row') {
        const isSelected = item.ship.deviceId === this.selected_ship

        return {
          // Добавляем класс для выделенной строки
          class: isSelected ? 'selected-row' : '',
          // Добавляем deвейс ID для отслеживания кликов
          'data-device-id': item.ship.deviceId,
          // Добавляем обработчик клика по строке
          onclick: isSelected ? "this.querySelector('td:first-child').classList.add('selected-header')" : ''
        }
      }
      return {}
    },

    // Обработчик клика по строке таблицы для раскрытия или скрытия деталей
    toggleDetails(index, deviceId, isOpen) {
      this.clearAllHighlightedCells()

      // Проверяем валидность индекса
      if (index < 0) {
        console.warn('Invalid index for toggleDetails:', index)
        return
      }

      // Получаем массив кораблей
      const fleet = this.fleetStore.getFleet
      if (!fleet || !Array.isArray(fleet)) {
        console.warn('Fleet data is not available')
        return
      }

      // Обновляем индекс открытой ячейки
      if (this.openedDetailIndex === index) {
        this.openedDetailIndex = null
      } else {
        // Закрываем предыдущие детали, если они были открыты
        if (this.openedDetailIndex !== null && this.openedDetailIndex >= 0) {
          // Находим текущий открытый элемент и закрываем его
          if (fleet.length > this.openedDetailIndex && fleet[this.openedDetailIndex]) {
            // Устанавливаем флаг _showDetails в false на предыдущем открытом элементе
            this.$set(fleet[this.openedDetailIndex], '_showDetails', false)
          }
        }

        // Сохраняем индекс новой открытой ячейки
        this.openedDetailIndex = index

        // Находим элемент и устанавливаем флаг _showDetails в true
        if (fleet.length > index && fleet[index]) {
          // Устанавливаем флаг _showDetails в true на текущем элементе
          this.$set(fleet[index], '_showDetails', true)
        }
      }

      // Используем встроенный bootstrap-vue's метод для раскрытия делатей
      if (this.$refs.fleetTable) {
        // Испольуем $nextTick чтобы убедиться что DOM обновился
        this.$nextTick(() => {
          if (this.$refs.fleetTable.toggleDetails) {
            this.$refs.fleetTable.toggleDetails(index)
          }
        })
      }

      // Если детали открыты, загружаем дополнительные данные для корабля
      if (isOpen && deviceId) {
        this.momentaryStore.startBackgroundLoading('toggleDetails', 'Loading ship details...')
        Promise.all([
          loadFleetLogbook(deviceId, true),
          loadFleetDeliveries(deviceId, '2024-12-06T10:16:06.695Z', true), // TODO
          loadFleetFolio(deviceId, true)
          // loadWeather(deviceId, true)
        ]).finally(() => {
          this.momentaryStore.stopBackgroundLoading('toggleDetails')
        })
      }

      // Сохраняем deviceId выбранного корабля
      this.selected_ship = deviceId

      this.$nextTick(() => {
        const rows = document.querySelectorAll('.ship-table tbody tr')
        rows.forEach(row => {
          const firstCell = row.querySelector('td:first-child')
          if (firstCell) {
            if (row.classList.contains('selected-row')) {
              firstCell.style.backgroundColor = '#e6f2ff'
            } else {
              firstCell.style.backgroundColor = ''
            }
          }
        })
      })

      // Получаем позицию корабля из AIS данных и сохраняем во флит сторе
      if (deviceId && this.fleetStore.AISData && this.fleetStore.AISData[deviceId]) {
        const aisData = this.fleetStore.AISData[deviceId]
        if (aisData && aisData.lat && aisData.lon) {
          // Сохраняем позицию корабля в хранилище
          this.fleetStore.selectedShipPosition = {
            lat: aisData.lat,
            lon: aisData.lon,
            cog: aisData.payload.CourseOverGround
          }
        } else {
          // Если позиция не найдена, очищаем ее в хранилище
          this.fleetStore.selectedShipPosition = null
        }
      } else {
        // Если нет данных AIS, очищаем позицию в хранилище
        this.fleetStore.selectedShipPosition = null
      }

      if (this.map) {
        this.map.setSelectedShip(deviceId)
      }
    },

    // Переключаем видимость панели поиска
    toggleSearchBar() {
      this.showSearchBar = !this.showSearchBar
      if (!this.showSearchBar) {
        this.searchQuery = ''
        this.filteredItems = null
      } else {
        this.$nextTick(() => {
          const inputElement = document.querySelector('.search-input')
          if (inputElement) inputElement.focus()
        })
      }
    },

    // Фильтруем таблицу по поисковому запросу
    filterTable() {
      if (!this.searchQuery.trim()) {
        this.filteredItems = null
        return
      }

      const query = this.searchQuery.toLowerCase()
      const fleet = this.fleetStore.getFleet || []

      // Фильтруем элементы флота по поисковому запросу
      this.filteredItems = fleet.filter(item => {
        const ship = item.ship
        return (
          (ship.name && ship.name.toLowerCase().includes(query)) ||
          (ship.deviceId && ship.deviceId.toLowerCase().includes(query)) ||
          (ship.imo && ship.imo.toLowerCase().includes(query)) ||
          (ship.mmsi && ship.mmsi.toLowerCase().includes(query)) ||
          (ship.agreement && ship.agreement.toLowerCase().includes(query))
        )
      })

      // Если есть отфильтрованные элементы, закрываем открытые детали
      this.collapseAllDetails()
    },

    // Проверяем наличие кораблей рядом с областями Navarea
    async checkShipsInNavareaWarnings() {
      const { fleetStore } = this

      // First, check if we have AIS data
      if (!fleetStore.AISData || Object.keys(fleetStore.AISData).length === 0) {
        return
      }

      try {
        // Загружаем данные Navarea если они еще не загружены
        if (!this.navareaData) {
          this.navareaData = await loadJSON('navarea.json') // TODO
        }

        // Инициализируем хранилище для хранения предупреждений Navarea для каждого корабля
        if (!fleetStore.alerts) {
          fleetStore.alerts = { navarea: {} }
        } else if (!fleetStore.alerts.navarea) {
          fleetStore.alerts.navarea = {}
        }

        // Проверяем каждый корабль который имеет AIS данные
        Object.entries(fleetStore.AISData).forEach(([deviceId, shipData]) => {
          if (!shipData || !shipData.lat || !shipData.lon) return

          const shipPosition = [shipData.lat, shipData.lon]
          let isInWarningArea = false
          let matchedWarning = null

          // Проверяем каждое предупреждение Navarea
          for (const warning of this.navareaData) {
            if (isInWarningArea) break // пропускам если уже нашли предупреждение

            // Проверяем точечные объекты в locationPoints
            if (warning.locationPoints && warning.locationPoints.length > 0) {
              for (const point of warning.locationPoints) {
                if (point.lat && point.lon) {
                  const pointPosition = [parseFloat(point.lat), parseFloat(point.lon)]
                  if (this.isPointWithinDistance(shipPosition, pointPosition, 10)) {
                    isInWarningArea = true
                    matchedWarning = warning
                    break
                  }
                }
              }
            }

            // TODO
            // Проверяем многоугольники в locationAreas
            // if (!isInWarningArea && warning.locationAreas && warning.locationAreas.length > 0) {
            //   for (const area of warning.locationAreas) {
            //     if (area.points) {
            //       // Обрабатываем точечные объекты
            //       if (!Array.isArray(area.points)) {
            //         if (area.points.lat && area.points.lon) {
            //           const pointPosition = [parseFloat(area.points.lat), parseFloat(area.points.lon)];
            //           if (this.isPointWithinDistance(shipPosition, pointPosition, 10)) {
            //             isInWarningArea = true;
            //             matchedWarning = warning;
            //             break;
            //           }
            //         }
            //       } else {
            //         // Обрабатываем многоугольную область
            //         const polygonPoints = area.points.map(point => [
            //           parseFloat(point.lat),
            //           parseFloat(point.lon)
            //         ]);
            //         if (this.isPointInOrNearPolygon(shipPosition, polygonPoints)) {
            //           isInWarningArea = true;
            //           matchedWarning = warning;
            //           break;
            //         }
            //       }
            //     }
            //   }
            // }
          }

          // Обновляем предупреждения для корабля в хранилище
          if (isInWarningArea && matchedWarning) {
            fleetStore.alerts.navarea[deviceId] = {
              position: shipPosition,
              warning: matchedWarning,
              timestamp: new Date().toISOString()
            }
          } else if (fleetStore.alerts.navarea[deviceId]) {
            delete fleetStore.alerts.navarea[deviceId]
          }
        })
      } catch (error) {
        console.error('Error checking ships in Navarea warnings:', error)
      }
    },

    // Если корабль находится в пределах заданной дистанции от точки Navarea
    isPointWithinDistance(point1, point2, maxDistanceKm) {
      // Простая аппроксимация с использованием теоремы Пифагора
      // Простая аппроксимация с использованием теоремы Пифагора
      const latDiff = Math.abs(point1[0] - point2[0]) * 111
      // Примерное вычисление изменения градуса долготы в зависимости от широты
      const avgLat = (point1[0] + point2[0]) / 2
      const lonDiff = Math.abs(point1[1] - point2[1]) * 111 * Math.cos((avgLat * Math.PI) / 180)

      // Вычисляем расстояние в километрах по теореме Пифагора
      const distance = Math.sqrt(latDiff * latDiff + lonDiff * lonDiff)

      return distance <= maxDistanceKm
    },

    // Если корабль находится в пределах заданной дистанции от области Navarea
    isPointInOrNearPolygon(point, polygonPoints) {
      //
      if (!polygonPoints || polygonPoints.length < 3) return false

      // Добавляем буферную зону
      const expandDegrees = 100 / 111 // прием что 100 км в одном градусе

      // Проверяем, находится ли точка внутри расширенного многоугольника
      // Используем алгоритм трассировки лучей для определения, находится ли точка в многоугольнике
      let inside = false
      for (let i = 0, j = polygonPoints.length - 1; i < polygonPoints.length; j = i++) {
        const xi = polygonPoints[i][0]
        const yi = polygonPoints[i][1]
        const xj = polygonPoints[j][0]
        const yj = polygonPoints[j][1]

        // Проверяем, находится ли точка рядом с любым сегментом многоугольника
        if (this.isPointNearLineSegment(point, [xi, yi], [xj, yj], expandDegrees)) {
          return true
        }

        // Алгоритм трассировки лучей для определения точки внутри многоугольника
        const intersect = yi > point[0] !== yj > point[0] && point[1] < ((xj - xi) * (point[0] - yi)) / (yj - yi) + xi
        if (intersect) inside = !inside
      }

      return false
    },

    // Проверяем, находится ли точка рядом с отрезком линии
    isPointNearLineSegment(point, lineStart, lineEnd, maxDistanceDegrees) {
      const x = point[1],
        y = point[0]
      const x1 = lineStart[1],
        y1 = lineStart[0]
      const x2 = lineEnd[1],
        y2 = lineEnd[0]

      // Расстояние между точкой и отрезком линии
      const A = x - x1
      const B = y - y1
      const C = x2 - x1
      const D = y2 - y1

      const dot = A * C + B * D
      const lenSq = C * C + D * D
      let param = -1

      if (lenSq !== 0) param = dot / lenSq

      let xx, yy

      if (param < 0) {
        xx = x1
        yy = y1
      } else if (param > 1) {
        xx = x2
        yy = y2
      } else {
        xx = x1 + param * C
        yy = y1 + param * D
      }

      const dx = x - xx
      const dy = y - yy
      const distance = Math.sqrt(dx * dx + dy * dy)

      return distance <= maxDistanceDegrees
    },

    // Проверяем, находится ли корабль в области Navarea
    isShipInNavareaWarning(deviceId) {
      const { fleetStore } = this
      return fleetStore.alerts && fleetStore.alerts.navarea && fleetStore.alerts.navarea[deviceId]
    },

    // Получаем CSS класс для иконки Navarea в зависимости от состояния корабля
    getNavareaIconClass(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля в alerts
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        return 'text-secondary' // серый цвет если нет данных
      }

      // Ищем записи типа "NavArea" для этого корабля
      const navareaAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'NavArea')

      if (navareaAlerts.length === 0) {
        return 'text-secondary' // серый цвет если нет данных о navarea
      }

      // Берем первую запись о navarea (предполагаем что самая актуальная)
      const navareaAlert = navareaAlerts[0]

      // Определяем цвет на основе поля color
      switch (navareaAlert.color) {
        case 'Red':
          return 'text-danger' // красный
        case 'Yellow':
          return 'text-warning' // желтый
        case 'Green':
          return 'text-success' // зеленый
        case 'NoColor':
        default:
          return 'text-secondary' // серый
      }
    },

    showWeatherData(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        this.$bvToast.toast('No weather data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Ищем записи типа "Wind" для этого корабля
      const windAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'Wind')

      if (windAlerts.length === 0) {
        this.$bvToast.toast('No wind data available for this ship', {
          title: 'Weather',
          variant: 'info',
          solid: true
        })
        return
      }

      // Находим корабль для получения имени
      const ship = fleetStore.getFleet.find(s => s.ship.deviceId === deviceId)

      // Формируем данные для модального окна на основе alerts
      this.modalWeatherData = {
        [deviceId]: {
          shipName: ship?.ship?.name || deviceId,
          alerts: windAlerts, // передаем все записи о ветре
          // Для совместимости с существующим модальным окном можем добавить:
          wind: windAlerts[0]?.texts.join('\n') || 'Нет данных',
          timestamp: new Date().toISOString()
        }
      }

      this.$bvModal.show('weather-modal')
    },

    // Показать подписку на алерты
    showAlertsSubscribe(deviceId) {
      this.modalAlertsSubscribe = [
        {
          deviceId: deviceId
        }
      ]

      this.$bvModal.show('alerts-subscribe-modal')
    },

    // Показываем предупреждения Navarea для корабля в модальном окне
    showNavareaWarnings(deviceId) {
      const { fleetStore } = this

      // Проверяем наличие данных об опасностях для корабля
      if (!fleetStore.alerts || !fleetStore.alerts[deviceId]) {
        this.$bvToast.toast('No Navarea for the ship', {
          title: 'Navarea Warnings',
          variant: 'info',
          solid: true
        })
        return
      }

      // Ищем записи типа "NavArea" для этого корабля
      const navareaAlerts = fleetStore.alerts[deviceId].filter(alert => alert.type === 'NavArea')

      if (navareaAlerts.length === 0) {
        this.$bvToast.toast('No Navarea for the ship', {
          title: 'Navarea Warnings',
          variant: 'info',
          solid: true
        })
        return
      }

      // Находим корабль для получения имени
      const ship = fleetStore.getFleet.find(s => s.ship.deviceId === deviceId)

      // Формируем данные для модального окна alerts на основе navarea alerts
      this.modalAlerts = navareaAlerts.map(alert => ({
        title: `NAVAREA Warning - ${ship?.ship?.name || deviceId}`,
        message: alert.texts.join('\n') || 'Нет подробностей',
        type: 'navarea',
        color: alert.color,
        timestamp: new Date().toISOString()
      }))

      this.$bvModal.show('alerts-modal')
    },

    // Метод для определения варианта иконки фолио (цвет)
    getFolioIconVariant(deviceId) {
      // Проверяем, есть ли алерт для фолио этого корабля
      const hasAlert = this.fleetStore.hasFolioAlert(deviceId)

      // Если есть алерт (нет самой детальной карты), возвращаем красный цвет
      if (hasAlert) {
        return 'danger'
      }

      // Если нет алерта (есть самая детальная карта), возвращаем зеленый цвет
      return 'success'
    },

    // Метод для показа модального окна с информацией о картах при клике на иконку фолио
    showFolioAlertDetails(deviceId) {
      const hasAlert = this.fleetStore.hasFolioAlert(deviceId)
      const charts = this.fleetStore.getFolioCharts(deviceId)
      const mostDetailed = this.fleetStore.alerts?.folio?.[deviceId]?.mostDetailed

      if (hasAlert) {
        // Если нет самой детальной карты, показываем предупреждение
        this.$bvModal
          .msgBoxConfirm(`The ship is missing the most detailed chart (${mostDetailed}) for its current position. Available charts: ${charts.join(', ')}. Would you like to purchase charts?`, {
            title: 'Chart Update Required',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Purchase Charts',
            cancelTitle: 'Cancel',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              this.$router.push('routes')
            }
          })
      } else if (charts.length > 0) {
        // Если есть все необходимые карты, показываем информационное сообщение
        this.$bvModal.msgBoxOk(`The ship has all necessary charts for its current position. Available charts: ${charts.join(', ')}`, {
          title: 'Charts Status',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'OK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
      } else {
        // Если данные о картах отсутствуют
        this.$bvModal.msgBoxOk('No chart data available for this ship', {
          title: 'Chart Information',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'secondary',
          okTitle: 'OK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
      }
    }
  }
}
</script>

<style scoped>
*,
*:after,
*:before {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
  min-height: 100vh;
  padding: 5rem 0;
  font-size: clamp(1rem, 2.5vw, 1.125rem);
}

section {
  width: 90%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

section+section {
  margin-top: 2.5em;
}

h1 {
  font-weight: 700;
  line-height: 1.125;
  font-size: clamp(1.5rem, 2.5vw, 2.5rem);
}

h2 {
  margin-top: 0.25em;
  color: #999;
  font-size: clamp(1.125rem, 2.5vw, 1.25rem);
}

h2+* {
  margin-top: 1.5em;
}

summary {
  background-color: #fff;
  position: relative;
  cursor: pointer;
  padding: 1em 0.5em;
  list-style: none;
}

summary::-webkit-details-marker {
  display: none;
}

summary:hover {
  background-color: #f2f5f9;
}

summary div {
  display: flex;
}

details {
  border-bottom: 1px solid #b5bfd9;
}

details[open] {
  box-shadow: -3px 0 0 #b5bfd9;
}

details:first-of-type {
  border-top: 1px solid #b5bfd9;
}

details>div {
  padding: 2em 2em 0;
  font-size: 0.875em;
}

dl dt {
  font-weight: 700;
}

dl dt a,
dl dt .b-link {
  font-weight: normal;
}

dl div {
  margin-right: 4em;
  margin-bottom: 0.5em;
}

/* Стили для изменения отображения dt и dd в деталях таблицы */
.ship-details-content>div {
  display: block;
  /* Изменяем с flex на block для вертикального расположения */
  margin-bottom: 6px;
}

.ship-details-content dt {
  font-weight: 500;
  min-width: 100px;
  margin-right: 0.5em;
  margin-bottom: 2px;
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
}

.ship-details-content dd {
  color: #686868;
  margin-bottom: 2px;
  margin-left: 0;
  /* Убираем левый отступ */
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
  margin-top: 2px;
  /* Небольшой отступ сверху для разделения от dt */
}

.folio-table .date-column {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
}

.folio-table th:last-child,
.folio-table td:last-child {
  text-align: right;
}

.folio-table th.date-column {
  text-align: right;
}

.ship-alerts {
  margin: 0 -2em 0 -2em;
}

.ship-alerts .alert {
  border-radius: 0;
  margin-bottom: 0;
}

.ship-alerts .alert:first-child {
  margin-top: -0.5rem;
}

.action-icons {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.table-danger {
  background-color: #f8d7da !important;
}

.table-striped tbody tr.table-danger:nth-of-type(odd),
.table-striped tbody tr.table-danger:nth-of-type(even) {
  background-color: #f8d7da !important;
}

details dd {
  color: #686868;
}

summary h6 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  padding: 0;
}

summary h6 strong,
summary h6 small,
summary h6 .ship-status-badge {
  margin-left: 0;
  align-self: flex-start;
}

details.selected {
  border-left: 7px solid #4299e1;
  background-color: rgba(66, 153, 225, 0.05);
}

.selected-summary {
  background-color: #ebf8ff !important;
}

.summary-header {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.summary-top-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.summary-bottom-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* Add this to push items to edges */
  align-items: center;
  /* Add this for vertical alignment */
}

.summary-left {
  text-align: left;
  flex: 1;
  /* Allow left side to take available space */
}

.summary-right {
  text-align: right;
  flex: 1;
  /* Allow right side to take available space */
  display: flex;
  justify-content: flex-end;
  /* Ensure content aligns to the right */
}

.normal-weight-badge {
  font-weight: normal !important;
}

.ship-name {
  font-size: 0.9em;
  font-weight: 500;
  /* Optional: slightly bolder to enhance readability */
}

.action-icons .action-icon {
  cursor: pointer;
}

.destination-eta {
  font-size: 0.9em;
  color: #767676;
}

.fleet-header {
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
}

.ships-container {
  max-height: calc(100vh - 100px);
  /* Adjust based on your layout */
  height: calc(100vh - 100px);
  /* Force full height */
  overflow-y: auto;
}

/* Custom scrollbar styling for Chrome, Edge, and Safari */
.ships-container::-webkit-scrollbar {
  width: 8px;
}

.ships-container::-webkit-scrollbar-track {
  background: #f2f5f9;
}

.ships-container::-webkit-scrollbar-thumb {
  background-color: #b5bfd9;
  border-radius: 4px;
}

.light-icon {
  color: #a0a0a0;
  /* Light gray color by default */
  transition: color 0.2s ease;
}

.light-icon:hover {
  color: #505050;
  /* Darker on hover for better interaction feedback */
}

/* Make sure the container takes the available height */
.ships-container {
  display: flex;
  flex-direction: column;
}

/* Styles for the ship table with row details */
.ship-table ::v-deep tr.b-table-details {
  background-color: #f8f9fa;
  width: 100%;
}

.ship-table ::v-deep tr.b-table-details>td {
  padding: 0;
}

.ship-details-content {
  padding: 10px;
  border-top: 1px solid #dee2e6;
  background-color: #f8f9fa;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  /* Prevent horizontal overflow */
  font-size: 0.9rem;
}

.ship-alerts {
  margin: 0 0 1em 0;
}

.ship-details-content>div {
  display: block;
  /* Изменяем с flex на block для вертикального расположения */
  margin-bottom: 6px;
}

.ship-details-content dt {
  font-weight: 500;
  min-width: 100px;
  margin-right: 0.5em;
  margin-bottom: 2px;
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
}

.ship-details-content dd {
  color: #686868;
  margin-bottom: 2px;
  margin-left: 0;
  /* Убираем левый отступ */
  word-break: break-word;
  overflow-wrap: break-word;
  display: block;
  /* Гарантируем блочное отображение */
  margin-top: 2px;
  /* Небольшой отступ сверху для разделения от dt */
}

.search-input {
  max-width: 200px;
  transition: all 0.3s ease;
}

@media (max-width: 576px) {
  .search-input {
    max-width: 120px;
  }
}

.ship-table {
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
  /* Add this to ensure text wraps */
  overflow-wrap: break-word;
  /* Modern browsers */
}

.ship-table .selected-row {
  background-color: #e6f2ff !important;
  /* Light blue background */
  border-left: 3px solid #3498db;
  /* Blue left border for emphasis */
}

.ship-table ::v-deep tr.b-table-details>td {
  padding: 0;
  box-sizing: border-box;
  width: 100%;
}

.ship-table .selected-row:hover {
  background-color: #d1e6ff !important;
  /* Slightly darker blue on hover */
}

.selected-row td:first-child {
  background-color: #e6f2ff !important;
  /* Light blue for the header */
}

.selected-row:hover td:first-child {
  background-color: #d1e6ff !important;
  /* Slightly darker on hover */
}

.clickable-badge {
  cursor: pointer;
}

.clickable-badge:hover {
  opacity: 0.8;
}

.custom-ship-badge {
  text-align: center;
  white-space: normal;
  display: inline-block;
}

.ship-table ::v-deep td {
  max-width: 100%;
  overflow-wrap: break-word;
  /* Ensure text wraps */
  word-wrap: break-word;
  /* Older browsers */
}

.ship-table ::v-deep td.selected-header {
  background-color: #e6f2ff !important;
}

/* Make this selector more specific and use ::v-deep to penetrate component boundaries */
.ship-table ::v-deep tr.selected-row>td:first-child {
  background-color: #e6f2ff !important;
}

.ship-table ::v-deep tr.selected-row:hover>td:first-child {
  background-color: #d1e6ff !important;
}

/* Also try this alternative selector that targets all cells in the row */
.ship-table ::v-deep tr.selected-row td {
  background-color: rgba(230, 242, 255, 0.5) !important;
}

.ship-table ::v-deep tr.selected-row td:first-child {
  background-color: #e6f2ff !important;
  border-left: 3px solid #3498db;
}

/* Make table in details more compact */
.ship-details-content table {
  font-size: 0.85rem;
  /* Even smaller text for tables */
}

.ship-details-content .ship-alerts .alert {
  padding: 0.4rem 0.75rem;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

/* Make the icon slightly smaller and properly aligned */
.ship-details-content .ship-alerts .alert i {
  margin-right: 0.5rem;
  font-size: 0.9em;
}

/* Make sure alert text is all on one line */
.ship-details-content .ship-alerts .alert {
  line-height: 1.2;
}

/* Ensure the alert container takes minimum space */
.ship-details-content .ship-alerts {
  margin: 0 0 0.75em 0;
}

/* Improved styling for alerts in ship details */
.ship-details-content .ship-alerts {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0 0 0.75em 0;
  width: 100%;
}

.ship-details-content .ship-alerts .alert {
  padding: 0.4rem 0.75rem;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Ensure icon alignment is consistent */
.ship-details-content .ship-alerts .alert i {
  margin-right: 0.5rem;
  font-size: 0.9em;
  flex-shrink: 0;
}

/* Fix line height to prevent multi-line alerts */
.ship-details-content .ship-alerts .alert {
  line-height: 1.2;
  min-height: 2rem;
}

/* Add a subtle separator between alerts */
.ship-details-content .ship-alerts .alert+.alert {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

/* Fix the vertical alignment of alert close buttons */
.ship-details-content .ship-alerts .alert .close {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  margin: 0;
  font-size: 1.25rem;
  line-height: 1;
  opacity: 0.5;
}

/* Ensure the alert has proper padding for the close button */
.ship-details-content .ship-alerts .alert {
  position: relative;
  padding-right: 2.5rem;
  /* Add extra space on the right for the close button */
}

/* Ensure text is vertically centered */
.ship-details-content .ship-alerts .alert {
  display: flex;
  align-items: center;
  min-height: 2.25rem;
}

.ship-details-content .ship-alerts .alert .close,
.ship-details-content .ship-alerts .alert ::v-deep .close {
  position: absolute !important;
  right: 0.75rem !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 1.25rem !important;
  line-height: 1 !important;
  opacity: 0.5;
}

/* Improve position of the alert container */
.ship-details-content .ship-alerts .alert {
  position: relative !important;
  padding-right: 2.5rem !important;
  display: flex !important;
  align-items: center !important;
  min-height: 2.25rem !important;
}

/* Make sure the close button appears above other elements */
.ship-details-content .ship-alerts .alert .close {
  z-index: 5 !important;
}

.ship-details-content .ship-alerts .alert .close,
.ship-details-content .ship-alerts .alert .btn-close,
.ship-details-content .ship-alerts .alert ::v-deep .close,
.ship-details-content .ship-alerts .alert ::v-deep .btn-close {
  position: absolute !important;
  right: 0.75rem !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.25rem !important;
  line-height: 1 !important;
  z-index: 10 !important;
  width: 1.5rem !important;
  height: 1.5rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Ensure the alert container has proper spacing */
.ship-details-content .ship-alerts .alert {
  position: relative !important;
  padding: 0.4rem 0.75rem !important;
  padding-right: 2.5rem !important;
  margin-bottom: 0.25rem !important;
  display: flex !important;
  align-items: center !important;
  min-height: 2.25rem !important;
  box-sizing: border-box !important;
}

/* Mobile optimizations */
@media (max-width: 767px) {
  .ships-container {
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
  }

  .ship-details-content {
    padding: 1rem;
  }

  .mobile-nav-icon {
    display: inline-block;
  }
}

@media (min-width: 768px) {
  .mobile-nav-icon {
    display: none;
  }
}

@media (max-width: 767px) {

  .mobile-nav-icon,
  .collapse-icon,
  .refresh-icon,
  .add-ship-icon,
  .search-icon,
  .qr-icon {
    font-size: 1.5rem;
    padding: 0.5rem;
    margin-right: 0.7rem !important;
    margin-left: 0.7rem !important;
  }

  .mobile-nav-icon:first-child {
    margin-left: 0 !important;
  }

  .mobile-nav-icon i,
  .collapse-icon i,
  .refresh-icon i,
  .add-ship-icon i,
  .search-icon i {
    font-size: 1.5rem;
  }

  /* Ensure minimum touch target size */
  .d-flex.align-items-center {
    min-height: 3rem;
  }

  /* Make horizontal rules more compact */
  .ship-details-content hr {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  /* Reduce padding in the table detail rows */
  .ship-table ::v-deep tr.b-table-details>td {
    padding: 8px 12px;
  }

  /* Make sure alert containers are compact */
  .ship-details-content .ship-alerts {
    margin-bottom: 6px;
  }

  .ship-details-content .ship-alerts .alert {
    padding: 6px 10px;
    margin-bottom: 6px;
  }

  .clickable-alert {
    cursor: pointer;
    transition: opacity 0.2s;
  }

  .clickable-alert:hover {
    opacity: 0.9;
  }

  .ship-alerts {
    margin: 0 0 12px 0;
  }

  .clickable-alert {
    cursor: pointer !important;
    position: relative !important;
    z-index: 10 !important;
    pointer-events: auto !important;
  }

  .clickable-alert:hover {
    opacity: 0.9 !important;
  }

  /* Remove any potential interfering elements */
  .clickable-alert .close,
  .clickable-alert .btn-close {
    display: none !important;
  }

  /* Make sure the entire alert is clickable */
  .clickable-alert>div {
    pointer-events: none;
  }

  /* Increase the height of the alert boxes */
  .custom-alert {
    padding: 0.75rem 0.75rem;
    /* Increased vertical padding */
    margin-bottom: 0.5rem;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 20;
    min-height: 3rem;
    /* Set a minimum height for alerts */
  }

  /* Adjust container margins to reduce space before first and after last alert */
  .ship-alerts {
    margin: 0.5rem 0 0.5rem 0;
    /* Reduced top and bottom margins */
  }

  /* Make sure first alert has no extra top margin */
  .ship-alerts>div:first-child {
    margin-top: 0;
  }

  /* Make sure last alert has no extra bottom margin */
  .ship-alerts>div:last-child {
    margin-bottom: 0;
  }

  .alert-details-list {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .alert-details-list .custom-alert {
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    padding: 12px 15px;
    background-color: #f8d7da;
    border-left: 4px solid #dc3545;
  }

  .alert-details-list dt {
    font-weight: normal !important;
    color: #000000 !important;
    min-width: 150px;
    flex-shrink: 0;
    margin-bottom: 0;
  }

  .alert-details-list dd {
    flex: 1;
    margin-bottom: 0;
    color: #721c24;
  }

  .alert-details-list .custom-alert+.custom-alert {
    margin-top: 10px;
  }

  .alert-details-list {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .alert-details-list .custom-alert {
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    padding: 12px 15px;
    background-color: #f8d7da;
    border-left: 4px solid #dc3545;
    width: 100%;
    /* Ensure full width */
  }

  /* Fix the width constraints on dt/dd elements */
  .alert-details-list dt {
    font-weight: normal !important;
    color: #000000 !important;
    width: 150px;
    /* Fixed width for title */
    min-width: 150px;
    flex-shrink: 0;
    margin-bottom: 0;
    margin-right: 15px;
    /* Add some space between dt and dd */
  }

  .alert-details-list dd {
    flex: 1;
    margin-bottom: 0;
    margin-right: 0;
    /* Remove right margin */
    color: #721c24;
    width: calc(100% - 165px);
    /* Calculate remaining width */
  }

  /* Remove any right margin that might be inherited from other dl styles */
  dl div {
    margin-right: 0;
    margin-bottom: 0.5em;
    width: 100%;
  }

  /* Make sure parent containers don't restrict width */
  .ship-details-content {
    padding: 10px;
    width: 100%;
    max-width: 100%;
  }

  /* Ensure alerts take full width */
  .ship-details-content dl div,
  .ship-details-content .alert-details-list {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }

  /* Fix nested dt/dd elements in alerts */
  .alert-details-list .custom-alert {
    display: flex !important;
    flex-direction: row !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
  }

  /* Remove width restriction on parent container */
  .ship-details-content {
    width: 100% !important;
    max-width: 100% !important;
    padding: 10px !important;
    box-sizing: border-box !important;
  }

  /* Force tables to take full width */
  .ship-table,
  .ship-table tr,
  .ship-table td {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Fix any potential overflow issues */
  .ship-details-content dd {
    overflow-wrap: break-word !important;
    word-wrap: break-word !important;
  }
}

.alert-container dt,
.custom-alert dt {
  font-weight: normal !important;
  color: #000000 !important;
}

.ship-badge {
  background: #f5f6fa;
  border-radius: 6px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 0.9em;
  min-width: 90px;
  min-height: 35px;
  font-weight: 700;
}

</style>
